import { Injectable } from '@angular/core';
import { FsRequestService } from '@fairandsmart/angular';
import {
  EntityCollection, EntityIdentifierHelper, EntityName, FsRequest, RequestFilter,
} from '@fairandsmart/types';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { OrgaService } from '@Services/orga.service';
import { FlexIndexableEntity, FlexIndexDocument, FlexSearchService } from '../flex-search.service';
import { FlexEntityIndexer } from './flex-entity-indexer';
import { FlexIndexDocumentHelper } from '../flex-index-document.helper';

@Injectable()
export class RequestIndexerService extends FlexEntityIndexer<FsRequest, RequestFilter> {
  constructor(
    flexSearch: FlexSearchService,
    protected fsRequestService: FsRequestService,
    private orgaService: OrgaService,
  ) {
    super(EntityName.REQUEST, flexSearch);
  }

  isHandling(entity: FlexIndexableEntity): boolean {
    return entity.entityName === EntityName.REQUEST;
  }

  handle(request: FsRequest): Observable<FlexIndexDocument> {
    const doc: FlexIndexDocument<string> = FlexIndexDocumentHelper.from(request);
    return of(null).pipe(
      map(() => {
        if (EntityIdentifierHelper.isOfType(request.emitter, EntityName.RECIPIENT)) {
          doc.c = EntityIdentifierHelper.extractId(request.emitter);
        }
        return doc;
      }),
    );
  }

  protected search(filter: RequestFilter): Observable<EntityCollection<FsRequest>> {
    return this.fsRequestService.search(filter);
  }

  protected getFilter(since: number, offset: number): RequestFilter {
    return {
      receiver: this.orgaService.reference,
      from: since,
      limit: this.batchNumber,
      offset,
      order: 'modificationDate',
    };
  }
}
